import React, { memo } from 'react'
import { Card, Grid2, useTheme } from '@mui/material'

import CardHeading from '../text/CardHeading'
import { STAKING_SYMBOL } from '../../util/wallet/staking.helpers'
import { Image } from '../image'
import { THEME_MODE } from '../../libs/qb-brand-web-components'
import OutsideLink from '../links/OutsideLink'

const GetStaking = ({ t }) => {
  const data = [
    {
      id: 'gateio',
      to: 'https://www.gate.io/trade/QBX_USDT'
    },
    {
      id: 'uniswap',
      to: 'https://app.uniswap.org/explore/tokens/ethereum/0x72fdc31f4a9a1edf6b6132d3c1754f1cdcf5d9b1'
    },
    {
      id: 'mexc',
      to: 'https://www.mexc.com/en-GB/exchange/QBX_USDT'
    },
    {
      id: 'bitmart',
      to: 'https://www.bitmart.com/trade/en-US?symbol=QBX_USDT'
    }
  ]
  const theme = useTheme()
  return (
    <Card
      sx={{
        p: 3,
        width: 1
      }}
    >
      <CardHeading
        title={t('home.where-to-get-staking', { symbol: STAKING_SYMBOL })}
      />
      <Grid2 container rowSpacing={3} columnSpacing={3}>
        {data.map(({ id, to }) => (
          <Grid2
            key={id}
            sx={{
              bgcolor: 'background.neutral',
              borderRadius: 2,
              p: 2
            }}
            size={{ xs: 6, sm: 6, md: 6 }}
            component={OutsideLink}
            label={
              <Image
                src={`/assets/exchange-logos/${id}-${theme.palette.mode === THEME_MODE.DARK ? 'w' : 'b'}.png`}
              />
            }
            to={to}
          ></Grid2>
        ))}
      </Grid2>
    </Card>
  )
}

export default memo(GetStaking)
